// GAVION skip-callback (93_gavion_skip_callback.sql): « Skip callback » and the « Requested » / « Auto » labels.
export const callbacksEn = {
  kind: {
    requested: "Requested",
    requested_hint: "The person asked for this callback",
    auto: "Auto",
    auto_hint: "Automatic follow-up after a voicemail, a brochure or no answer",
  },
  skip: {
    action: "Skip callback",
    action_for: "Skip the callback of %{name}",
    reason_title: "Why?",
    reasons: {
      inaccurate: "Inaccurate",
      already_done: "Already done",
      not_relevant: "No longer relevant",
    },
    done: "Callback removed",
    errors: {
      forbidden:
        "Only the company's assigned rep or an admin can remove this callback.",
      no_callback: "This company no longer has a callback.",
      not_found: "Company not found.",
      unknown: "The callback could not be removed. Try again.",
    },
  },
};
